import { render, staticRenderFns } from "./EmbroideryDetails.vue?vue&type=template&id=0ba5b0fe&scoped=true&"
import script from "./EmbroideryDetails.vue?vue&type=script&lang=js&"
export * from "./EmbroideryDetails.vue?vue&type=script&lang=js&"
import style0 from "./EmbroideryDetails.vue?vue&type=style&index=0&id=0ba5b0fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba5b0fe",
  null
  
)

export default component.exports